import { useQuery } from '@tanstack/react-query';
import { getGuidesFromClient } from '~/pages/api/guides';

const KEY = 'guides-search';

export function getGuidesKey() {
   return [KEY];
}

export function useGuides(query: string) {
   const RESULT_LIMIT = 10;

   return useQuery({
      queryKey: [KEY, query],
      queryFn: async () => {
         return await getGuidesFromClient({ query, limit: RESULT_LIMIT });
      },
      keepPreviousData: true,
   });
}
